// For Bootstrap you can specify which plugins you need:
// import { Tooltip, Toast, Popover } from 'bootstrap';
// Alternatively, if you only need just a few of our plugins, you may import plugins individually as needed:
// import Alert from 'bootstrap/js/dist/alert';
import { Carousel, Modal, Dropdown } from "bootstrap";

import "common/js/script/globals";
import "common/js/script/menu";

//Startup script
import InitVue from "common/js/script/startup/initvue";
import InitScript from "common/js/script/startup/initscript";
import ObserveNavigation from "common/js/script/startup/observeNavigation";

//Vue Components
import MobileMenu from "common/js/vue/menu/MobileMenu.vue";
import SidebarMenu from "common/js/vue/menu/SidebarMenu.vue";
import HeaderSearch from "common/js/vue/sitesearch/headersearch.vue";
import SiteSearch from "common/js/vue/sitesearch/sitesearch.vue";
import Comments from "common/js/vue/comments/comments.vue";

/**
 * Listan nedan används för att:
 * 1. Initiera vue komponenter vid vanlig sidomladdning.
 * 2. Initiera om vue komponenter vid sidomladdning som sker via vår spa-funktionalitet om komponenten finns på den nya sidan.
 *
 * Om man lägger till egenskapen: "doNotObserve: true" så kommer komponenten endast att initieras vid vanlig sidomladdning.
 */
InitVue.initVue([
  {
    container: "#mainmenu-mobile-vue",
    component: MobileMenu,
    doNotObserve: true,
  },
  { container: "#sidebar-menu-vue", component: SidebarMenu },
  { container: "#headersearch-vue", component: HeaderSearch },
  { container: "#sitesearch-vue", component: SiteSearch },
  { container: ".comments", component: Comments },
]);

//Script
import Accordion from "common/js/script/accordion";
import Bilder from "common/js/script/bilder";
import Video from "common/js/script/video";
import Sok from "common/js/script/sok";
import Header from "./script/header";
import changeEpiQuickNavigatorEditLink from "common/js/script/changeEpiQuickNavigatorEditLink";
import Redigerasida from "../../CommonFrontend/js/script/redigerasida";
/**
 * Listan nedan används för att:
 * 1. Köra script funktioner vid vanlig sidomladdning.
 * 2. Köra script funktioner vid sidomladdning som sker via vår spa-funktionalitet den nya sidan har
 *    ett element som stämmer in på selectorn som specificeras för egenskapen: "observeSelector".
 *
 * Om man inte lägger till egenskapen: "observeSelector" så körs endast funktionen vid en vanlig sidomladdning.
 */
InitScript.initScript([
  { initFunc: Accordion.initAccordion, observeSelector: "p.foldable" },
  { initFunc: Video.initVideo, observeSelector: ".livesandning, .videoblock" },
  {
    initFunc: Bilder.initBilder,
    observeSelector: ".qbankmediawrapper .bildText",
  },
  { initFunc: Sok.initSok },
  { initFunc: Header.initHeader },
  { initFunc: changeEpiQuickNavigatorEditLink.init },
  { initFunc: Redigerasida.initRedigerasida }
]);

/**
 * Observerar ifall en sidomladdning via vår spa-funktionalitet har skett och initierar om de vue komponenter och
 * kör de script funktioner som är specificerade i listorna ovan.
 *
 * Man kan även lägga in en lista med länk-element(<a>) för att de länkarna ska agera som spa-länkar.
 * Om man kör funktionen utan några parametrar så fungerar ändå spa-länkar som är definierade på annat håll.
 */
ObserveNavigation.startObserve(
  [
    {
      linkSelector: "a:not(.disable-spa-link)",
      eventId: "All links",
    }
  ],
  document.getElementById("screen-reader-navigate-to-prefix")?.innerText
);
